<template>
  <div class="show-answer" v-if="isShowAnswer">
    <el-divider content-position="left">答题解析</el-divider>
    <el-form-item v-if="isShowAnswerReviews" label="解析内容">
      <el-input type="textarea" v-model="reviews.content" :autosize="{minRows:2}" resize="none"></el-input>
    </el-form-item>
    <el-form-item v-if="isShowAnswerGrammar" label="关联语法">
      <GrammarSelect v-model="reviews.grammar_id"></GrammarSelect>
    </el-form-item>
  </div>
</template>

<script>
import GrammarSelect from '@/components/grammar/GrammarSelect.vue'

export default {
  name: 'ShowAnswer',
  props: {
    value: Object,
    config: Object
  },
  components: { GrammarSelect },
  watch: {
    value () {
      this.initShowAnswer()
    }
  },
  data () {
    return {
      reviews: {}
    }
  },
  computed: {
    isShowAnswer() {
      return this.config.showReviewsContent || this.config.showReviewsGrammar
    },
    isShowAnswerGrammar() {
      return this.config.showReviewsGrammar
    },
    isShowAnswerReviews() {
      return this.config.showReviewsContent
    }
  },
  mounted () {
    this.initShowAnswer()
  },
  methods: {
    initShowAnswer () {
      this.$nextTick(() => {
        if (!this.isShowAnswer) {
          if ('reviews' in this.value) {
            delete this.value.reviews
          }
          return
        }
        if (!this.value.reviews) {
          this.value.reviews = {}
        }
        this.reviews = this.value.reviews
      })
    }
  }
}
</script>